"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_CONFIG_COLUMN_DEFS = exports.ViewConfigRowSchema = exports.ContentDbRefSchema = exports.EntryStyleSchema = exports.PaginationModeSchema = exports.NavModeSchema = exports.RowDetailModeSchema = exports.LayoutTypeSchema = void 0;
exports.getViewConfigColumnId = getViewConfigColumnId;
exports.parseRow = parseRow;
const zod_1 = require("zod");
const custom_app_config_1 = require("./custom-app-config");
const formula_1 = require("./formula");
exports.LayoutTypeSchema = zod_1.z.enum(['list', 'grid', 'kanban', 'dashboard']);
exports.RowDetailModeSchema = zod_1.z.enum(['none', 'page', 'modal']);
exports.NavModeSchema = zod_1.z.enum(['none', 'top', 'sidebar', 'both']);
exports.PaginationModeSchema = zod_1.z.enum(['none', 'numbered', 'infinite']);
exports.EntryStyleSchema = zod_1.z.enum([
    'plain',
    'card',
    'image-card',
    'hero-card',
]);
exports.ContentDbRefSchema = zod_1.z
    .object({
    databaseId: zod_1.z.string().min(1),
    docId: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
    contentModel: custom_app_config_1.CustomAppContentModelSchema,
})
    .strict();
const OptionalStringStorageSchema = zod_1.z.preprocess(value => (value === null ? undefined : value), zod_1.z.string().optional());
exports.ViewConfigRowSchema = zod_1.z.object({
    viewId: zod_1.z.string().min(1),
    name: zod_1.z.string(),
    slugPrefix: OptionalStringStorageSchema,
    layoutType: exports.LayoutTypeSchema,
    rowDetailMode: exports.RowDetailModeSchema,
    inlineEdit: zod_1.z.boolean(),
    nav: exports.NavModeSchema,
    search: zod_1.z.boolean(),
    pagination: exports.PaginationModeSchema,
    hero: zod_1.z.boolean(),
    entryStyle: exports.EntryStyleSchema,
    tags: zod_1.z.boolean(),
    form: zod_1.z.boolean(),
    seoSlugCol: zod_1.z.string().nullable(),
    seoMetaCol: zod_1.z.string().nullable(),
    seoOgCol: zod_1.z.string().nullable(),
    seoCanonicalCol: zod_1.z.string().nullable(),
    seoRobotsIndex: zod_1.z.boolean(),
    seoTitleFormula: formula_1.FormulaSchema.nullable().optional(),
    seoDescriptionFormula: formula_1.FormulaSchema.nullable().optional(),
    seoOgImageFormula: formula_1.FormulaSchema.nullable().optional(),
    contentDbRef: exports.ContentDbRefSchema.nullable(),
    customAppConfig: custom_app_config_1.CustomAppConfigSchema.optional(),
    // sl-ya4v.4b-E (Cluster E removal): per-view `domain` field deleted.
    // Routing target now lives at the routing entity: `custom_domains.custom_app_id`
    // FK (migration 270). Service-side validation in CustomDomainService ensures
    // the bound view belongs to the same workspace.
    themeRef: zod_1.z.string().nullable(),
    bindings: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    isDefault: zod_1.z.boolean(),
});
function deriveBlockSuiteType(zodType) {
    let t = zodType;
    if (t instanceof zod_1.z.ZodNullable || t instanceof zod_1.z.ZodOptional) {
        t = t._def.innerType;
    }
    if (t instanceof zod_1.z.ZodBoolean)
        return 'checkbox';
    if (t instanceof zod_1.z.ZodEnum)
        return 'select';
    if (t instanceof zod_1.z.ZodNumber)
        return 'number';
    return 'rich-text';
}
exports.VIEW_CONFIG_COLUMN_DEFS = (() => {
    const shape = exports.ViewConfigRowSchema.shape;
    return Object.keys(shape).map(field => ({
        field,
        zodType: shape[field],
        blockSuiteType: deriveBlockSuiteType(shape[field]),
    }));
})();
function getViewConfigColumnId(field) {
    return `view-config:${String(field)}`;
}
function parseRow(raw) {
    if (raw && typeof raw === 'object') {
        (0, custom_app_config_1.validateNoDeprecatedBlobFields)(raw['customAppConfig']);
    }
    return exports.ViewConfigRowSchema.parse(raw);
}
